import React, { useEffect, useState, useContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { es } from "date-fns/locale";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getShift, updateShift, deleteShift } from "../api";

const EditShiftForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const { id_shift } = useParams();

  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));

  // helpers
  const formatTime = (date) => {
    if (!date) return null;
    const h = String(date.getHours()).padStart(2, "0");
    const m = String(date.getMinutes()).padStart(2, "0");
    return `${h}:${m}:00`;
  };

  const timeStrToDate = (hhmmss) => {
    if (!hhmmss) return null;
    const [h, m] = String(hhmmss).split(":").map(Number); // ignora segundos si vienen
    const d = new Date();
    d.setHours(h || 0, m || 0, 0, 0);
    return d;
  };

  const [idShift, setIdShift] = useState(id_shift || "");
  const [timeBegin, setTimeBegin] = useState(null);
  const [timeEnd, setTimeEnd] = useState(null);
  const [observations, setObservations] = useState("");

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        const data = await getShift(company?.id_c, id_shift);
        if (!data) {
          alert(t("No se pudo cargar el turno"));
          return navigate(-1);
        }
        setIdShift(data.id_shift);
        setTimeBegin(timeStrToDate(data.time_begin)); // "HH:mm:ss" o "HH:mm"
        setTimeEnd(timeStrToDate(data.time_end));
        setObservations(data.observations || "");
      } catch (e) {
        console.error("❌ Error getShift:", e);
        alert(t("Ocurrió un error al cargar el turno."));
        return navigate(-1);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [company?.id_c, id_shift, navigate, t]);

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const payload = {
        time_begin: formatTime(timeBegin),
        time_end: formatTime(timeEnd),
        observations,
        // opcional: id_user: user?.id_u
      };
      await updateShift(company?.id_c, idShift, payload);
      alert(t("Turno actualizado"));
      navigate(-1);
    } catch (error) {
      console.error("❌ Error updateShift:", error);
      alert(t("Ocurrió un error al actualizar el turno."));
    } finally {
      setSaving(false);
    }
  };

  const handleDelete = async () => {
    if (!window.confirm(t("¿Eliminar este turno?"))) return;
    try {
      await deleteShift(company?.id_c, idShift);
      alert(t("Turno eliminado"));
      navigate(-1);
    } catch (error) {
      console.error("❌ Error deleteShift:", error);
      alert(t("Ocurrió un error al eliminar el turno."));
    }
  };

  if (loading) return <p className="box1">{t("Cargando...")}</p>;

  return (
    <div className="box1">
      <div className="box9">
        <form onSubmit={handleSave}>
          <table className="form1">
            <tbody>
              <tr>
                <td><label>{t("ID Shift")}</label></td>
                <td>
                  <input className="input1" value={idShift} disabled />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="time_ini">{t("batchList8")}</label></td>
                <td>
                  <DatePicker
                    selected={timeBegin}
                    onChange={(date) => setTimeBegin(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText="Selecciona hora"
                    className="input1"
                    id="time_ini"
                    name="time_ini"
                    required
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="time_fin">{t("batchList10")}</label></td>
                <td>
                  <DatePicker
                    selected={timeEnd}
                    onChange={(date) => setTimeEnd(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText="Selecciona hora"
                    className="input1"
                    id="time_fin"
                    name="time_fin"
                    required
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="observations">{t("shifts2")}</label></td>
                <td>
                  <textarea
                    className="input1"
                    id="observations"
                    name="observations"
                    rows="3"
                    value={observations}
                    onChange={(e) => setObservations(e.target.value)}
                    required
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <button type="submit" className="button7" disabled={saving || !timeBegin || !timeEnd}>
            {saving ? t("Guardando...") : t("Guardar")}
          </button>
          <button type="button" className="button7" onClick={() => navigate(-1)}>
            {t("Cancelar")}
          </button>
          <button type="button" className="button7" onClick={handleDelete}>
            {t("Borrar")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default EditShiftForm;
